import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {UOMUtil} from '../../utils/uomUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class AdminTripGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var tripGrid = this;
		setTimeout(function(){
			tripGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var tripGrid = this;	
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},	
				{						
					path: 'tripRefNo',
					header: 'Trip Ref No',
					width: '7em'
				},
				{						
					path: 'tripStartDts',
					header: 'Start Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.tripStartDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'tripEndDts',
					header: 'End Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.tripEndDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'stops',
					header: 'Stop Count',
					width: '7em',					
					renderer: function(root, column, rowData) {			
						root.innerHTML = rowData.item.stops.length;						
					}
				},
				{						
					path: 'plannedDistance',
					header: 'Planned Distance',
					width: '7em',
					'text-align': 'end',
					renderer: function(root, column, rowData) {
						root.innerHTML = UOMUtil.sumTripStopDistances(rowData.item);
					}
				},
				{						
					path: 'actualDistance',
					header: 'Actual Distance',
					width: '7em',
					'text-align': 'end',
					renderer: function(root, column, rowData) {
						root.innerHTML = UOMUtil.sumFinalDistance(rowData.item.actualDistance.distances);
					}
				},
				{						
					path: 'tripComment',
					header: 'Trip Comment',
					width: '7em'
				},
				{						
					path: 'entryMethodDescription',
					header: 'Entry Method',
					width: '7em',
					hidden: true
				},				
				{						
					path: 'originalFilename',
					header: 'Original Filename',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateUser',
					header: 'Update User',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',
					hidden: true,
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var calcTotals = function(records) {			
			var totalDistance = 0;
			var totalToll = 0;
			var totalFerry = 0;
			records.forEach(function(record) {
				record.stops.forEach(function(stop) {
					stop.stopDistance.distances.forEach(function(d){
					var finalD = d.finalDistance;
					
					var distance = finalD.distance ? finalD.distance : 0;
					var toll = finalD.tollDistance ? finalD.tollDistance : 0;
					var ferry = finalD.ferryDistance ? record.ferryDistance : 0;

					if (record.distanceUom === 'KM') {
						totalDistance += UOMUtil.convertKMToMI(distance);
						totalToll += UOMUtil.convertKMToMI(toll);
						totalFerry += UOMUtil.convertKMToMI(ferry);
					} else {
						totalDistance += distance;
						totalToll += toll;
						totalFerry += ferry;
					}
					});
				});
				
			});
			return {
				totalDistance: Math.round(totalDistance * 10)/10,
				totalToll: Math.round(totalToll * 10)/10,
				totalFerry: Math.round(totalFerry * 10)/10
			};
		};	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {
					
					var totals = calcTotals(grid.selectedItems);					
					selectedDistanceStatus.innerHTML = '<b>Selected Distance:</b> ' + totals.totalDistance + 
							' Toll: ' + totals.totalToll + 
							' Ferry: ' + totals.totalFerry + 
							' MI | ';
				} else {						
					
					selectedDistanceStatus.innerHTML = '';
				}					
			});
		};	
		
		var selectedDistanceStatus = ElementUtil.create({
			tag: 'span'
		});
		
		var distanceStatus = ElementUtil.create({
			tag: 'span',			
			trustedInnerHTML: true,
			innerHTML: '<b>Planned Distance:</b> 0 MI'
		});				
		
		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',
			itemid: 'trips',
			children: [
				{
					tag: 'span',
					slot: 'status',
					children: [
						selectedDistanceStatus,						
						distanceStatus
					]
				}
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					var companyId = ElementUtil.query(tripGrid.toolbarFilter, 'filterCompany').value;						
					if (companyId) {
						DataManagementService.getAdminDataService().exportTrips(grid.currentFilter);					
					} else {
						ElementUtil.query(tripGrid.toolbarFilter, 'filterCompany').validate();
						window.DL.MessageUtil.showToastError('A Company must be selected');
					}
				}
			}
		});
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
									
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(tripGrid.toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(tripGrid.toolbarFilter, 'filterEndDate').value);		
									
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'tripStartDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',								
							start: startFilterDts,														
							end: endFilterDts,
							filterField: 'tripRefNo',
							filterValue: ElementUtil.query(tripGrid.toolbarFilter, 'filterTripRefNo').value, 
							dateField: 'tripStartDts'
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
							gridSelectionChange();
							
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();
							
							var totals = calcTotals(records.data);					
							distanceStatus.innerHTML = '<b>Planned Distance:</b> ' + totals.totalDistance + 
							' Toll: ' + totals.totalToll + 
							' Ferry: ' + totals.totalFerry + 
							' MI | ';				
						};
						
						var companyId = ElementUtil.query(tripGrid.toolbarFilter, 'filterCompany').value;
						
						if (companyId) {
							var tractorId = ElementUtil.query(tripGrid.toolbarFilter, 'filterTractorId').value;
							if (tractorId) {						
								DataManagementService.getAdminDataService().getTrips(companyId, tractorId, grid.currentFilter).then(function(records){
									successHandler(records);
								});						
							} else {
								loadMask.remove();
								if (tripGrid.nextLoadOfGrid) {
									ElementUtil.query(tripGrid.toolbarFilter, 'filterTractorId').validate();								
									window.DL.MessageUtil.showToastError('A tractor must be selected');
								} else {
									tripGrid.nextLoadOfGrid = true;
								}
							}
						} else {
							loadMask.remove();
							ElementUtil.query(tripGrid.toolbarFilter, 'filterCompany').validate();								
							window.DL.MessageUtil.showToastError('A Company must be selected');
						}						
						
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [				
				grid,
				footerContainer
			]
		});		
		tripGrid.append(flexLayout);	

		tripGrid.actionRefresh = function() {
			pagingToolbar.loadPage(1);
		};		
		
		tripGrid.clearData = function() {
			grid.items = [];
		};
	
	}
	
	refreshGrid() {
		var tripGrid = this;		
		tripGrid.actionRefresh();
	}
	
	clearGrid() {
		var tripGrid = this;
		tripGrid.clearData();
	}
	
	
	setFilterContainer(filterContainer) {
		var tripGrid = this;		
		tripGrid.toolbarFilter = filterContainer;
	}
	
}
customElements.define('dl-admin-trip-grid', AdminTripGrid);


